import type { CaptchaVO, EmailCodeDTO, LoginDTO, LoginVO, RegisterDTO, ResetPasswordDTO, Response, ServiceApiLoginReq, SsoLoginVO } from './types';
import { get, post } from '@/utils/request';

export const login = (data: LoginDTO) => post<Response<LoginVO>>('/auth/login', data).json();

// 邮箱验证码
export const emailCode = (data: EmailCodeDTO) => post('/resource/email/code', data).json();

// 注册账号
export const register = (data: RegisterDTO) => post('/auth/register', data).json();

// 重置密码
export const resetPassword = (data: ResetPasswordDTO) => post('/auth/reset/password', data).json();

// 获取图形验证码
export const getCaptcha = () => get<CaptchaVO>('/auth/code').json();

// SSO 统一登录
export const ssoLogin = (data: ServiceApiLoginReq) => post<Response<SsoLoginVO>>('/sso/login', data).json();
